import {ChemicalStructureDrawerValue} from 'chemistry/marvinjs-wrappers/ChemicalStructureDrawer';
import {ChemistryReactionRole} from 'notebook/integrations/chemistry/ChemistryStructuredTableConstants';
import {ChemicalStructureSearchOperator, Operator} from 'search/SearchConstants';

export interface MoleculeChemSearchSubmit {
  mode: 'molecule';
  chemicalStructureQuery: string;
  chemSearchOperator: ChemicalStructureSearchOperator;
  minSimilarity?: number;
}

export interface ReactionChemSearchSubmit {
  mode: 'reaction';
  chemicalStructureQuery: string;
  chemSearchOperator: ChemicalStructureSearchOperator;
  minSimilarity?: number;
  reactionComponentRole: ChemistryReactionRole | null;
}

export type ChemSearchSubmit = MoleculeChemSearchSubmit | ReactionChemSearchSubmit;

export interface ChemSearchSubmitResult {
  submit: ChemSearchSubmit | null;
  minSimilarityToSave?: number;
}

function getMinSimilarityToSave(
  chemSearchOperator: ChemicalStructureSearchOperator,
  minSimilarity: number
): number | undefined {
  return chemSearchOperator === Operator.SIMILARITY ? minSimilarity : undefined;
}

export interface MoleculeChemSearchSubmitInput {
  mol: ChemicalStructureDrawerValue;
  chemSearchOperator: ChemicalStructureSearchOperator;
  minSimilarity: number;
}

export function buildMoleculeChemSearchSubmitPayload(
  input: MoleculeChemSearchSubmitInput
): ChemSearchSubmitResult {
  const {mol, chemSearchOperator, minSimilarity} = input;

  const minSimilarityToSave = getMinSimilarityToSave(chemSearchOperator, minSimilarity);
  if (mol == null) {
    return {submit: null, minSimilarityToSave};
  }

  const submit: MoleculeChemSearchSubmit = {
    mode: 'molecule',
    chemicalStructureQuery: mol,
    chemSearchOperator,
    minSimilarity: minSimilarityToSave,
  };

  return {submit, minSimilarityToSave};
}

export interface ReactionChemSearchSubmitInput {
  mol: ChemicalStructureDrawerValue;
  chemSearchOperator: ChemicalStructureSearchOperator;
  minSimilarity: number;
  reactionComponentRole: ChemistryReactionRole | null;
}

export function buildReactionChemSearchSubmitPayload(
  input: ReactionChemSearchSubmitInput
): ChemSearchSubmitResult {
  const {mol, chemSearchOperator, minSimilarity, reactionComponentRole} = input;
  const minSimilarityToSave = getMinSimilarityToSave(chemSearchOperator, minSimilarity);
  if (mol == null) {
    return {submit: null, minSimilarityToSave};
  }
  const submit: ReactionChemSearchSubmit = {
    mode: 'reaction',
    chemicalStructureQuery: mol,
    chemSearchOperator,
    minSimilarity: minSimilarityToSave,
    reactionComponentRole,
  };
  return {submit, minSimilarityToSave};
}
